export type AssessmentOccasion = string;

const STORAGE_KEY = "tk.assessmentOccasion";

export function getSelectedAssessmentOccasion(): AssessmentOccasion | null {
  return localStorage.getItem(STORAGE_KEY);
}

export function saveSelectedAssessmentOccasion(occasion: AssessmentOccasion) {
  localStorage.setItem(STORAGE_KEY, occasion);
}

export function questionMatchesAssessmentOccasion<T extends { event_id?: string | null }>(
  question: T,
  eventId: AssessmentOccasion | null = getSelectedAssessmentOccasion()
) {
  return question.event_id == null || question.event_id === "" || question.event_id === eventId;
}
